import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(apiErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-lm-cream">
      <div className="w-full max-w-sm lm-anim">
        <img src="/logo-mascheroni.webp" alt="LM" className="h-9 mb-8" />
        {sent ? (
          <div className="text-center">
            <MailCheck className="w-12 h-12 text-lm-terra mx-auto mb-4" />
            <h2 className="font-display text-2xl text-lm-text mb-2">Controlla la tua email</h2>
            <p className="text-sm text-lm-muted mb-6" data-testid="forgot-confirm">Se l'email è registrata, riceverai un link per reimpostare la password.</p>
            <Link to="/login" className="text-sm text-lm-terra hover:underline inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Torna all'accesso</Link>
          </div>
        ) : (
          <>
            <h2 className="font-display text-3xl text-lm-text mb-1">Recupera password</h2>
            <p className="text-sm text-lm-muted mb-8">Ti invieremo un link per reimpostarla.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required data-testid="forgot-email" value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white border-lm-sandsoft" />
              </div>
              {error && <p className="text-sm text-[#991B1B]">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-lm-brown hover:bg-lm-brownh text-lm-cream h-11">
                {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Invia link
              </Button>
              <div className="text-center">
                <Link to="/login" className="text-sm text-lm-terra hover:underline inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Torna all'accesso</Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
